export enum ProductType {
    PRODUCT_SET = 'PRODUCT_SET',
    MONO_SKU = 'MONO_SKU',
    MULTI_SKU_SIZE = 'MULTI_SKU_SIZE',
    MULTI_SKU_SHADE_UNI = 'MULTI_SKU_SHADE_UNI',
    MULTI_SKU_SHADE_DIFF = 'MULTI_SKU_SHADE_DIFF',
}
